import {Palette} from 'hubbl-shared';
import {MenuItem} from 'react-pro-sidebar';
import styled from 'styled-components';
import {AssetIconMenu} from '../../../../assets';
import {AppLogo} from '../../../../assets/branding/AssetAppLogo';
import {useAppSelector} from '../../../../hooks';
import {CompanySelector} from '../../../../store/company/CompanySelector';
import {useStorageImageUrl} from '../../../../hooks/api/useStorageImageUrl';

interface MenuItemsContainerProps {
  isCollapsed: boolean;
  onClick: () => void;
  isMobile?: boolean;
}
const SidebarTopMenuContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 15px;

  @media (max-width: 768px) {
    margin-left: 0;
    justify-content: center;
  }
`;

const LogoWrapper = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
`;

export const SidebarMenuHeader = ({
  isCollapsed,
  onClick,
  isMobile = false,
}: MenuItemsContainerProps) => {
  const company = useAppSelector(CompanySelector.getCompanyDetails);
  const logoStorageRef = company?.logoUrl;
  const logoUrl = useStorageImageUrl(logoStorageRef);

  return (
    <MenuItem
      onClick={onClick}
      icon={isCollapsed && !isMobile ? <AssetIconMenu /> : undefined}
      style={{margin: '10px 0 20px 0', color: Palette.almostBlack500}}>
      {!isCollapsed && (
        <SidebarTopMenuContainer>
          {logoUrl ? (
            <LogoWrapper>
              <img
                src={logoUrl}
                alt="Company logo"
                style={{height: 24, width: 'auto', display: 'block'}}
              />
            </LogoWrapper>
          ) : (
            <AppLogo size={100} />
          )}
          {!isMobile && <AssetIconMenu />}
        </SidebarTopMenuContainer>
      )}
    </MenuItem>
  );
};
